import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LocalPrintshopIcon from '@mui/icons-material/LocalPrintshop';
import {
  Box,
  Button,
  Chip,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  SelectChangeEvent,
  Stack,
  TextField
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Loader from 'src/components/common/Loader';
import { PopupComponent } from 'src/components/common/PopupComponent';
import printPdfWithViewer from 'src/components/common/PrintPdfWithViewer';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { useUser } from 'src/components/hooks/useUser';
import { getPoratlHost } from 'src/components/hooks/useUtil';
import { hideLoader, showLoader } from 'src/store/Loader';
import { setMessage } from 'src/store/Message';
import { setConfirmExitValue } from 'src/store/confirmExitValue';
import { useAppSelector } from 'src/store/hooks';
import { IForm1572Select } from 'src/types/Form1572';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { formatInput } from 'src/util/STR';
import { Form1572DocUpload } from '../../documentUpload/Form1572DocUpload';
import { useDocumentUploads } from '../../documentUpload/useDocumentUploads';
import '../StudyLogs.scss';
import { useFrom1572 } from './useForm1572';
import { setIsbacktositepersonnel } from 'src/store/SiteStudyPersonnel';
import { setPath } from 'src/store/Navigation';
import { useTab } from 'src/components/hooks/useTab';
import { archLevel } from 'src/data/config';
import ESignConsentReAuth from 'src/components/common/ESignConsentReAuth';
import { useLazySetESignQuery } from 'src/services/ESignAPI';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import { useValidUserForReAuth } from '../../../hooks/useValidUserForReAuth';

const Form1572: React.FunctionComponent<any> = ({
  setStudyLogOpen,
  setTrainingOpen,
  setForm1572Open,
  setIsForm1572VersionClickable,
  setUpdated1572Version,
  setForm1572EtmfDocumentMetaId,
  setForm1572EtmfTmfDocumentId
}) => {
  const { isValidUserForReAuth } = useValidUserForReAuth();
  const [openSignConsent, setOpenSignConsent] = useState(false);
  const { selectedAppSection } = useSelectedAppInfo();
  const { applicationModuleSection, unSavedWarning } = useFieldTranslation();
  const { checkPermission } = usePermissionWrapper();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const dispatch = useDispatch();
  const { getAllISFDocInfoByArtifactNumberSiteLevelData, deleteMasterDocumentIsf, getIsfDocDetailsByStudyDocIdQuerry } =
    useDocumentUploads();
  const {
    form1572QueryData,
    getForm1572IsError,
    updateForm1572QueryIsError,
    createForm1572QueryIsError,
    getForm1572QueryData,
    updateForm1572Query,
    publishForm1572Query,
    updateSignForm1572QueryIsError,
    publishForm1572QueryIsError,
    createForm1572Query
  } = useFrom1572();
  const { user } = useUser();
  const { getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const token = useAppSelector(state => state.user.user?.token);
  const sponsor = useAppSelector(state => state.user.user?.sponsor);
  // const token = ((getState() as RootState)?.user?.user as any)?.token;
  // const sponsor = ((getState() as RootState)?.user?.user as any)?.sponsor;
  const updatePermission = checkPermission('update_1572_form');
  const signPermission = checkPermission('sign_1572_form');
  const publishPermission = checkPermission('publish_1572_form');
  const viewDocsPermission = checkPermission('view_1572_form_documents');
  const manageDocsPermission = checkPermission('manage_1572_form_documents');
  const [unSavedChanges, setUnSavedChanges] = useState(false);
  const [openChangeCVandOSQ, setOpenChangeCVandOSQ] = useState(false);
  const [isFormUpdated, setIsFormUpdated] = useState(false);
  const [isFormCreated, setIsFormCreated] = useState(false);
  const [newFormVersion, setNewFormVersion] = useState<number>(1);
  const [confirmSign, setConfirmSign] = useState(false);
  const [confirmNewVersion, setConfirmNewVersion] = useState(false);
  const [openLinkISFDocument, setOpenLinkISFDocument] = useState(false);
  const [existingISFDocId, setExistingISFDocId] = useState<string>('');
  const [isUploadedDocExisted, setIsUploadedDocExisted] = useState(false);
  const [deleteExistingDocPopup, setDeleteExistingDocPopup] = useState(false);
  const [deleteExistingAndLinkDocPopup, setDeleteExistingAndLinkDocPopup] = useState(false);
  const [originallyAssociated1572Document, setOriginallyAssociated1572Document] = useState({});
  const isBacktoSitepersonnel = useAppSelector(state => state.siteStudyPersonnel.isBacktoSitepersonnel);
  const { setTabVal, tabsData } = useTab();
  const new1572Form = {
    form_1572: {
      ffst_version: 0,
      ffst_name_investigator: null,
      ffst_add1_inv: null,
      ffst_add2_inv: null,
      ffst_add_city_inv: null,
      ffst_add_state_inv: null,
      ffst_add_country_inv: null,
      ffst_add_zip_inv: null,
      ffst_inv_cv: null,
      ffst_inv_other_qualifications: null,
      ffst_statement_rfac: null,
      ffst_name_rfac: null,
      ffst_add1_rfac: null,
      ffst_add2_rfac: null,
      ffst_city_rfac: null,
      ffst_state_rfac: null,
      ffst_country_rfac: null,
      ffst_zip_rfac: null,
      ffst_name_clinlab: null,
      ffst_add1_clinlab: null,
      ffst_add2_clinlab: null,
      ffst_city_clinlab: null,
      ffst_state_clinlab: null,
      ffst_country_clinlab: null,
      ffst_zip_clinlab: null,
      ffst_name_irb: null,
      ffst_add1_irb: null,
      ffst_add2_irb: null,
      ffst_city_irb: null,
      ffst_state_irb: null,
      ffst_country_irb: null,
      ffst_zip_irb: null,
      ffst_subinv_names: null,
      ffst_protocol_id: null,
      ffst_protocol_info: null,
      ffst_phase1_statement: null,
      ffst_phase2_or3_statement: null,
      ffst_commitments: null,
      ffst_instructions: null,
      ffst_date_sign_statement: null,
      ffst_date_signed: null,
      ffst_signature: null,
      reason: null,
      ffst_publish_isf: null,
      ffst_omb_statement: null,
      id: ''
    }
  };
  const [validationObj, setValidationObj] = useState({
    ffst_name_investigator: false,
    ffst_add1_inv: false,
    ffst_add_city_inv: false,
    ffst_add_state_inv: false,
    ffst_add_country_inv: false,
    ffst_add_zip_inv: false,
    ffst_inv_cv: false,
    ffst_inv_other_qualifications: false,
    ffst_name_rfac: false,
    ffst_add1_rfac: false,
    ffst_city_rfac: false,
    ffst_state_rfac: false,
    ffst_country_rfac: false,
    ffst_zip_rfac: false,
    ffst_name_clinlab: false,
    ffst_add1_clinlab: false,
    ffst_city_clinlab: false,
    ffst_state_clinlab: false,
    ffst_country_clinlab: false,
    ffst_zip_clinlab: false,
    ffst_name_irb: false,
    ffst_add1_irb: false,
    ffst_city_irb: false,
    ffst_state_irb: false,
    ffst_country_irb: false,
    ffst_zip_irb: false,
    ffst_phase1_statement: false,
    ffst_phase2_or3_statement: false
  });

  const [form1572Data, setForm1572Data] = useState<any>(new1572Form);
  const [savedFormFields, setSavedFormFields] = useState<any>(new1572Form.form_1572);
  const [updatedDocsList, setUpdatedDocsList] = useState<any>([]);
  const isFieldDisabled = !(
    updatePermission &&
    (form1572Data.form_1572.ffst_signature === null || form1572Data.form_1572.ffst_signature === '')
  );

  const uploadDocArtifacts = {
    cv: {
      name: 'Investigator CV',
      number: '05.01.01'
    },
    osq: {
      name: 'Statement of qualification',
      number: '05.01.02 '
    }
  };
  const [documentMetaData, setDocumentMetaData] = useState({
    name: '',
    number: ''
  });
  const [docsListToLink, setDocsListToLink] = useState([]);
  const getFormData = async () => {
    await getForm1572QueryData({
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      application_module_section: 'STUDY LOGS'
    });
  };
  const getTempDocArray = async (
    fileIdsObj: { file_id: string; is_uploaded: boolean },
    publishProp: string,
    signatureProp: string
  ) => {
    let tempDocsList: any = [];
    let associatedDoc: any = {};
    try {
      const result: any = await getIsfDocDetailsByStudyDocIdQuerry({
        study_id: studyId,
        site_id: selectedSite,
        country: selectedCountry,
        documentId: fileIdsObj.file_id,
        application: process.env.REACT_APP_NAME,
        module_section_related: 'STUDY LOGS',
        parent_entity_related: ''
      });
      const docResult: any = result?.data;
      associatedDoc = { ...docResult, is_uploaded: fileIdsObj.is_uploaded };
      tempDocsList = [
        {
          file_master_id: docResult.file_master.id,
          document_id: docResult.document_data.id,
          document_name: docResult.document_data.isf_document_name,
          is_uploaded: fileIdsObj.is_uploaded
        }
      ];
    } catch (error: any) {
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      }
    }
    getDocsChipList(tempDocsList, publishProp === 'Y', signatureProp !== null && signatureProp !== '');
    setUpdatedDocsList(tempDocsList);
    setOriginallyAssociated1572Document(associatedDoc);
  };
  useEffect(() => {
    getFormData();
  }, [selectedSite]);
  const createNew1572Form = (isNewForm: boolean, newFormVersion: number) => {
    const tempCreateObj = {
      form_1572: {
        ffst_version: newFormVersion,
        created_by: user
      },
      uploaded_file_details: [],
      new_version: isNewForm
    };
    formApiRequest(true, tempCreateObj);
    getFormData();
  };
  useEffect(() => {
    if (form1572QueryData) {
      if (Object.keys(form1572QueryData).length > 0) {
        dispatch(showLoader());
        if (Object.keys(form1572QueryData)) {
          setFormData(form1572QueryData);
          setIsForm1572VersionClickable(
            form1572QueryData.form_1572.ffst_version > 1 || form1572QueryData.form_1572.ffst_publish_isf === 'Y'
          );
          setUpdated1572Version(form1572QueryData.form_1572.ffst_version);
          setForm1572EtmfDocumentMetaId(form1572QueryData.form_1572.tp_document_meta_id);
          setForm1572EtmfTmfDocumentId(form1572QueryData.form_1572.tp_document_id);
        } else {
          setForm1572Data(new1572Form);
          setSavedFormFields(new1572Form.form_1572);
          setUpdatedDocsList([]);
          setIsForm1572VersionClickable(false);
          setUpdated1572Version(1);
          setForm1572EtmfDocumentMetaId('');
          setForm1572EtmfTmfDocumentId('');
        }
        dispatch(hideLoader());
      }
    }
  }, [form1572QueryData]);

  /* set the form data to refresh the form1572Data
   **/
  const setFormData = (result: any) => {
    setForm1572Data(result);
    setSavedFormFields(result.form_1572);
    setNewFormVersion(result.form_1572.ffst_version);
    setIsFormCreated(true);
    if (result.file_details?.length > 0) {
      getTempDocArray(result.file_details[0], result.form_1572.ffst_publish_isf, result.form_1572.ffst_signature);
    } else {
      getDocsChipList(
        [],
        result.form_1572.ffst_publish_isf === 'Y',
        result.form_1572.ffst_signature !== null && result.form_1572.ffst_signature !== ''
      );
      setUpdatedDocsList([]);
    }
  };
  /* end of setFormData
   **/
  const navigateToSitInfo = () => {
    dispatch(setPath('1572'));
    const currentTabinfo: any = tabsData.filter((item: any) => item.key === 'siteContactInfo');
    setTabVal(currentTabinfo[0].index);
  };
  useEffect(() => {
    return () => {
      dispatch(setIsbacktositepersonnel(false));
    };
  }, []);

  const handleBack1572 = () => {
    if (isFormUpdated) {
      setUnSavedChanges(true);
      dispatch(setIsbacktositepersonnel(false));
    } else if (isBacktoSitepersonnel) {
      navigateToSitInfo();
      dispatch(setIsbacktositepersonnel(false));
    } else {
      setConfirmExitValue(dispatch, false);
      setStudyLogOpen(true);
      setForm1572Open(false);
    }
  };

  const handleFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const formattedVal = typeof event.target.value === 'string' ? formatInput(event.target.value) : event.target.value;
    const value = formattedVal;
    const updated1572Obj = {
      ...form1572Data,
      form_1572: {
        ...form1572Data.form_1572,
        [event.target.name as keyof IForm1572Select]: value
      }
    };
    setForm1572Data(updated1572Obj);
    if (event.target.name in validationObj) {
      const updatedValidatoinObj = {
        ...validationObj,
        [event.target.name]: false
      };
      setValidationObj(updatedValidatoinObj);
    }
    setIsFormUpdated(true);
    setConfirmExitValue(dispatch, true);
  };

  const [eduRadioNameValue, setEduRadioNameValue] = useState<any>({});
  const handleEduRadioFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (form1572Data.form_1572.ffst_inv_other_qualifications === 'N' || form1572Data.form_1572.ffst_inv_cv === 'N') {
      if (updatedDocsList.length > 0) {
        setEduRadioNameValue({
          name: event.target.name,
          value: event.target.value
        });
        setOpenChangeCVandOSQ(true);
      } else {
        modifyEduRadioFields(event.target.name, event.target.value);
      }
    } else {
      modifyEduRadioFields(event.target.name, event.target.value);
    }
  };

  const handleCancelChangeCVandOSQ = () => {
    setOpenChangeCVandOSQ(false);
  };
  const handleConfirmChangeCVandOSQ = () => {
    //delete uploaded document in the form
    setOpenChangeCVandOSQ(false);
    handleDocDeleteconfirm();
    setUpdatedDocsList([]);
    getDocsChipList(
      [],
      form1572Data.form_1572.ffst_publish_isf === 'Y',
      form1572Data.form_1572.ffst_signature !== null && form1572Data.form_1572.ffst_signature !== ''
    );
    dispatch(setMessage({ msgDetails: 'Document deleted successfully', severity: 'success' }));
    modifyEduRadioFields(eduRadioNameValue.name, eduRadioNameValue.value);
  };

  const modifyEduRadioFields = (propName: string, propValue: string) => {
    const formattedVal = typeof propValue === 'string' ? formatInput(propValue) : propValue;
    const value = formattedVal;
    if (propName === 'ffst_inv_cv') {
      setForm1572Data({
        ...form1572Data,
        form_1572: {
          ...form1572Data.form_1572,
          [propName as keyof IForm1572Select]: value,
          ffst_inv_other_qualifications: 'N'
        }
      });
      setSavedFormFields({
        ...savedFormFields,
        [propName as keyof IForm1572Select]: value,
        ffst_inv_other_qualifications: 'N'
      });
    } else {
      setForm1572Data({
        ...form1572Data,
        form_1572: {
          ...form1572Data.form_1572,
          [propName as keyof IForm1572Select]: value,
          ffst_inv_cv: 'N'
        }
      });
      setSavedFormFields({
        ...savedFormFields,
        [propName as keyof IForm1572Select]: value,
        ffst_inv_cv: 'N'
      });
    }
    if (propName in validationObj) {
      const updatedValidatoinObj = {
        ...validationObj,
        ffst_inv_other_qualifications: false,
        ffst_inv_cv: false
      };
      setValidationObj(updatedValidatoinObj);
    }
  };
  const handleProtoRadioFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const formattedVal = typeof event.target.value === 'string' ? formatInput(event.target.value) : event.target.value;
    const value = formattedVal;
    if (event.target.name === 'ffst_phase1_statement') {
      setForm1572Data({
        ...form1572Data,
        form_1572: {
          ...form1572Data.form_1572,
          [event.target.name as keyof IForm1572Select]: value,
          ffst_phase2_or3_statement: 'N'
        }
      });
    } else {
      setForm1572Data({
        ...form1572Data,
        form_1572: {
          ...form1572Data.form_1572,
          [event.target.name as keyof IForm1572Select]: value,
          ffst_phase1_statement: 'N'
        }
      });
    }
    if (event.target.name in validationObj) {
      const updatedValidatoinObj = {
        ...validationObj,
        ffst_phase2_or3_statement: false,
        ffst_phase1_statement: false
      };
      setValidationObj(updatedValidatoinObj);
    }
    setIsFormUpdated(true);
    setConfirmExitValue(dispatch, true);
  };

  const handleCreateNewFormConfirm = () => {
    handleCreateNewFormClose();
    setUpdatedDocsList([]);
    getDocsChipList([], false, false);
    setNewFormVersion(form1572Data.form_1572.ffst_version + 1);
    setIsFormCreated(false);
    setForm1572Data(new1572Form);
    setSavedFormFields(new1572Form.form_1572);
    createNew1572Form(true, form1572Data.form_1572.ffst_version + 1);
  };
  const handleCreateNewFormClose = () => {
    setConfirmNewVersion(false);
  };
  const [setESignature] = useLazySetESignQuery();
  const handle1572FormSign = async (data: any = {}) => {
    if (data.success) {
      if (!isValidUserForReAuth(data.records.user_name)) {
        dispatch(setMessage({ msgDetails: `Please e-sign with the logged in username`, severity: 'error' }));
      } else {
        setOpenSignConsent(false);
        dispatch(showLoader());
        const dataObj = {
          username: data.records.user_name,
          password: data.records.password,
          module_name: applicationModuleSection.form1572,
          name_of_signature: 'ffst_signature',
          name_of_date_field: 'ffst_date_signed',
          id: form1572Data.form_1572.id,
          columns_to_change: {
            reason: data.records.sign_reason,
            ffst_date_sign_statement: null,
            ffst_publish_isf: null,
            updated_by: user
          }
        };
        const signatureResponse: any = await setESignature({
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME_TEMP,
          application_section: selectedAppSection,
          application_module_section: applicationModuleSection.studyLogs,
          data: dataObj
        });
        if (signatureResponse.isSuccess) {
          getFormData();
          getDocsChipList(updatedDocsList, false, true);
          dispatch(setMessage({ msgDetails: 'PI Signed', severity: 'success' }));
        } else if (signatureResponse.isError) {
          dispatch(setMessage({ msgDetails: `Authorization for ${data.records.user_name} failed`, severity: 'error' }));
        }
        dispatch(hideLoader());
      }
    }
  };

  const handleSignConfirm = async () => {
    handleSignClose();
    setOpenSignConsent(true);
  };

  const isPublishDisabled = () => {
    return form1572Data.form_1572.ffst_publish_isf === 'Y'
      ? true
      : form1572Data.form_1572.ffst_signature === null || form1572Data.form_1572.ffst_signature === ''
      ? true
      : !publishPermission
      ? true
      : false;
  };

  const handlePublishForm1572 = async () => {
    dispatch(showLoader());
    const publishResponse: any = await publishForm1572Query({
      id: form1572Data.form_1572.id,
      isUpdate: form1572Data.form_1572.ffst_version > 1 ? true : false,
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      application_module_section: 'STUDY LOGS'
    });
    if (publishResponse.isSuccess) {
      setIsFormUpdated(false);
      setConfirmExitValue(dispatch, false);
      getFormData();
      dispatch(setMessage({ msgDetails: 'Publish successful', severity: 'success' }));
    }
    dispatch(hideLoader());
  };
  const handleSignOpen = () => {
    resetValidationObj();
    if (isValidForm1572()) {
      if (updatedDocsList && updatedDocsList.length > 0) {
        setConfirmSign(true);
      } else {
        dispatch(setMessage({ msgDetails: 'Please upload document', severity: 'error' }));
      }
    }
  };
  const handleSignClose = () => {
    setConfirmSign(false);
  };

  const tooltipClosehandle = (name: string) => {
    if (name === 'move') {
      handle1572Close();
    }
    setUnSavedChanges(false);
  };

  const handle1572Close = () => {
    setConfirmExitValue(dispatch, false);
    setStudyLogOpen(true);
    setForm1572Open(false);
  };

  const resetValidationObj = () => {
    const newObj: any = { ...validationObj };
    for (const key of Object.keys(validationObj)) {
      newObj[key] = false;
    }
    setValidationObj(newObj);
  };

  const isValidForm1572 = () => {
    const newValidObj: any = { ...validationObj };
    const validationArr: any = [];
    for (const key of Object.keys(validationObj)) {
      if (form1572Data.form_1572[key] === '' || form1572Data.form_1572[key] === null) {
        newValidObj[key] = true;
        validationArr.push(false);
      }
    }
    setValidationObj(newValidObj);
    if (validationArr.includes(false)) {
      return false;
    } else {
      return true;
    }
  };
  const getPayloadObj = () => {
    const payloadObj = {
      form_1572: {
        ffst_version: form1572Data.form_1572.ffst_version,
        ffst_name_investigator: form1572Data.form_1572.ffst_name_investigator,
        ffst_add1_inv: form1572Data.form_1572.ffst_add1_inv,
        ffst_add2_inv: form1572Data.form_1572.ffst_add2_inv,
        ffst_add_city_inv: form1572Data.form_1572.ffst_add_city_inv,
        ffst_add_state_inv: form1572Data.form_1572.ffst_add_state_inv,
        ffst_add_country_inv: form1572Data.form_1572.ffst_add_country_inv,
        ffst_add_zip_inv: form1572Data.form_1572.ffst_add_zip_inv,
        ffst_inv_cv: form1572Data.form_1572.ffst_inv_cv,
        ffst_inv_other_qualifications: form1572Data.form_1572.ffst_inv_other_qualifications,
        ffst_name_rfac: form1572Data.form_1572.ffst_name_rfac,
        ffst_add1_rfac: form1572Data.form_1572.ffst_add1_rfac,
        ffst_add2_rfac: form1572Data.form_1572.ffst_add2_rfac,
        ffst_city_rfac: form1572Data.form_1572.ffst_city_rfac,
        ffst_state_rfac: form1572Data.form_1572.ffst_state_rfac,
        ffst_country_rfac: form1572Data.form_1572.ffst_country_rfac,
        ffst_zip_rfac: form1572Data.form_1572.ffst_zip_rfac,
        ffst_name_clinlab: form1572Data.form_1572.ffst_name_clinlab,
        ffst_add1_clinlab: form1572Data.form_1572.ffst_add1_clinlab,
        ffst_add2_clinlab: form1572Data.form_1572.ffst_add2_clinlab,
        ffst_city_clinlab: form1572Data.form_1572.ffst_city_clinlab,
        ffst_state_clinlab: form1572Data.form_1572.ffst_state_clinlab,
        ffst_country_clinlab: form1572Data.form_1572.ffst_country_clinlab,
        ffst_zip_clinlab: form1572Data.form_1572.ffst_zip_clinlab,
        ffst_name_irb: form1572Data.form_1572.ffst_name_irb,
        ffst_add1_irb: form1572Data.form_1572.ffst_add1_irb,
        ffst_add2_irb: form1572Data.form_1572.ffst_add2_irb,
        ffst_city_irb: form1572Data.form_1572.ffst_city_irb,
        ffst_state_irb: form1572Data.form_1572.ffst_state_irb,
        ffst_country_irb: form1572Data.form_1572.ffst_country_irb,
        ffst_zip_irb: form1572Data.form_1572.ffst_zip_irb,
        ffst_subinv_names: form1572Data.form_1572.ffst_subinv_names,
        ffst_protocol_id: form1572Data.form_1572.ffst_protocol_id,
        ffst_protocol_info: form1572Data.form_1572.ffst_protocol_info,
        ffst_phase1_statement: form1572Data.form_1572.ffst_phase1_statement,
        ffst_phase2_or3_statement: form1572Data.form_1572.ffst_phase2_or3_statement,
        ffst_commitments: form1572Data.form_1572.ffst_commitments,
        ffst_instructions: form1572Data.form_1572.ffst_instructions,
        ffst_date_signed: form1572Data.form_1572.ffst_date_signed,
        ffst_signature: form1572Data.form_1572.ffst_signature,
        ffst_publish_isf: form1572Data.form_1572.ffst_publish_isf,
        ffst_omb_statement: form1572Data.form_1572.ffst_omb_statement
      },
      uploaded_file_details:
        updatedDocsList !== undefined && updatedDocsList.length > 0
          ? updatedDocsList.map((file: any) => {
              return {
                file_id: file.document_id,
                is_uploaded: file.is_uploaded
              };
            })
          : []
    };
    return payloadObj;
  };

  const saveForm1572 = async () => {
    let tempUpdateObj = {
      ...getPayloadObj(),
      form_1572: {
        ...getPayloadObj().form_1572,
        id: form1572Data.form_1572.id,
        updated_by: user
      }
    };
    if (isFormCreated) {
      formApiRequest(false, tempUpdateObj);
    } else {
      const result: any = await getCreatedFormResult();
      if (result !== null) {
        tempUpdateObj = {
          ...tempUpdateObj,
          form_1572: {
            ...tempUpdateObj.form_1572,
            id: result.form_1572.id,
            ffst_version: result.form_1572.ffst_version
          }
        };
        setForm1572Data(tempUpdateObj);
        setSavedFormFields(tempUpdateObj.form_1572);
        setNewFormVersion(result.form_1572.ffst_version);
        setIsFormCreated(true);
        formApiRequest(false, tempUpdateObj);
      }
    }
  };
  const getCreatedFormResult = async () => {
    const tempCreateObj = {
      form_1572: {
        ffst_version: newFormVersion,
        created_by: user
      },
      uploaded_file_details: [],
      new_version: true
    };
    const createdFormResult: any = await createForm1572Query({
      data: tempCreateObj,
      site_id: selectedSite,
      study_id: studyId,
      country: selectedCountry,
      application: process.env.REACT_APP_NAME,
      application_module_section: 'STUDY LOGS'
    });
    if (createdFormResult.isSuccess) {
      saveSuccessfullMessage();
      return createdFormResult?.data;
    } else {
      return null;
    }
  };
  const formApiRequest = async (isCreateAPIReq: boolean, dataObj: any) => {
    dispatch(showLoader());
    if (isCreateAPIReq) {
      const result: any = await createForm1572Query({
        data: dataObj,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: process.env.REACT_APP_NAME,
        application_module_section: 'STUDY LOGS'
      });
      if (result.isSuccess) {
        setForm1572Data(result?.data);
        setSavedFormFields(result?.data?.form_1572);
        setIsFormCreated(true);
        setIsFormUpdated(false);
        setConfirmExitValue(dispatch, false);
      }
    } else {
      const updateResponse: any = await updateForm1572Query({
        data: dataObj,
        id: dataObj.form_1572.id,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: process.env.REACT_APP_NAME,
        application_module_section: 'STUDY LOGS'
      });
      if (updateResponse.isSuccess) {
        saveSuccessfullMessage();
        resetValidationObj();
        setIsFormUpdated(false);
        setConfirmExitValue(dispatch, false);
      }
    }
    dispatch(hideLoader());
  };

  useEffect(() => {
    if (getForm1572IsError) {
      setForm1572Data(new1572Form);
      setSavedFormFields(new1572Form.form_1572);
      setUpdatedDocsList([]);
    }
  }, [getForm1572IsError]);
  const saveSuccessfullMessage = () => {
    dispatch(setMessage({ msgDetails: 'Save successful', severity: 'success' }));
  };
  useEffect(() => {
    if (updateForm1572QueryIsError || createForm1572QueryIsError) {
      dispatch(setMessage({ msgDetails: 'Error while saving data', severity: 'error' }));
    }
    if (updateSignForm1572QueryIsError) {
      dispatch(setMessage({ msgDetails: 'Error while signing', severity: 'error' }));
    }
    if (publishForm1572QueryIsError) {
      dispatch(setMessage({ msgDetails: 'Error while publishing', severity: 'error' }));
    }
  }, [
    updateForm1572QueryIsError,
    createForm1572QueryIsError,
    updateSignForm1572QueryIsError,
    publishForm1572QueryIsError
  ]);
  /**
   * file upload start
   */
  const [openUploadDocument, setOpenUploadDocument] = useState<boolean>(false);
  const [openUploadLinkDocument, setOpenUploadLinkDocument] = useState<boolean>(false);
  const [deleteDocPopup, setDeleteDocPopup] = useState(false);
  const [docsChipList, setDocsChipList] = useState<any[]>([]);
  const handleDocView = (docToView: any) => {
    if (archLevel == 'site') {
      try {
        dispatch(showLoader());
        window.parent.postMessage(
          {
            action: 'PUSH_APP',
            slug_id: process.env.REACT_APP_ISF_SLUG,
            viewerDocument: {
              document_id: docToView.document_id,
              study_id: studyId,
              site_id: selectedSite,
              country: selectedCountry
            }
          },
          getPoratlHost()
        );
        dispatch(hideLoader());
      } catch (error: any) {
        dispatch(hideLoader());
        dispatch(setMessage({ msgDetails: 'Error viewing document', severity: 'error' }));
      }
    } else {
      showNotAllowedMessage();
    }
  };
  const showNotAllowedMessage = () => {
    dispatch(
      setMessage({ msgDetails: 'You are not allowed to view this document from sponsor portal', severity: 'error' })
    );
  };
  const handleChipDelete = (_: any) => {
    setDeleteDocPopup(true);
  };
  const handleDocDeletePopupClose = () => {
    setDeleteDocPopup(false);
  };
  const handleDocDeleteconfirm = async () => {
    try {
      setDeleteDocPopup(false);
      dispatch(showLoader());
      if (updatedDocsList[0].is_uploaded) {
        await deleteMasterDocumentIsf({
          file_master_id: updatedDocsList[0].file_master_id,
          study_id: studyId,
          country: selectedCountry,
          site_id: selectedSite,
          application: process.env.REACT_APP_NAME
        });
      }
      updateFormWithDocData({ uploaded_file_details: [] });
      handleCloseUploadDocument();
      setUpdatedDocsList([]);
      getDocsChipList(
        [],
        form1572Data.form_1572.ffst_publish_isf === 'Y',
        form1572Data.form_1572.ffst_signature !== null && form1572Data.form_1572.ffst_signature !== ''
      );
      dispatch(hideLoader());
      dispatch(setMessage({ msgDetails: 'Document delete successful', severity: 'success' }));
    } catch (error: any) {
      dispatch(hideLoader());
      if (error && error?.response?.status === 403) {
        dispatch(setMessage({ msgDetails: 'Error 403 Restricted User permission', severity: 'error' }));
      } else if (error && error.response?.status === 401) {
        dispatch(setMessage({ msgDetails: 'Error 401 Unauthorized access', severity: 'error' }));
      } else {
        dispatch(setMessage({ msgDetails: 'Error in Document Delete', severity: 'error' }));
      }
    }
  };

  const handleExistingDocDeleteconfirm = () => {
    setIsUploadedDocExisted(true);
    handleExistingDocDeletePopupClose();
    handleOpenUploadDocument();
  };
  const handleExistingDocDeletePopupClose = () => {
    setDeleteExistingDocPopup(false);
    setOpenUploadLinkDocument(false);
  };
  const handleExistingAndLinkDocDeleteconfirm = () => {
    handleExistingAndLinkDocDeletePopupClose();
    handleOpenLinkISFDocument();
  };
  const handleExistingAndLinkDocDeletePopupClose = () => {
    setDeleteExistingAndLinkDocPopup(false);
    setOpenUploadLinkDocument(false);
  };
  const updateFormWithDocData = async (uploadedFileObj: any) => {
    let changedDocRadioOption = {};
    if (Object.keys(eduRadioNameValue).length !== 0) {
      changedDocRadioOption =
        eduRadioNameValue.name === 'ffst_inv_cv'
          ? {
              [eduRadioNameValue.name as keyof IForm1572Select]: eduRadioNameValue.value,
              ffst_inv_other_qualifications: 'N'
            }
          : {
              [eduRadioNameValue.name as keyof IForm1572Select]: eduRadioNameValue.value,
              ffst_inv_cv: 'N'
            };
    }
    let tempUpdateObj = {
      form_1572: {
        ...savedFormFields,
        ...changedDocRadioOption,
        updated_by: user
      },
      ...uploadedFileObj
    };
    if (!isFormCreated) {
      const result: any = await getCreatedFormResult();
      if (result !== null) {
        tempUpdateObj = {
          ...tempUpdateObj,
          form_1572: {
            ...tempUpdateObj.form_1572,
            id: result.form_1572.id,
            ffst_version: result.form_1572.ffst_version
          }
        };
        const tempForm1572Data = {
          ...form1572Data,
          form_1572: {
            ...form1572Data.form_1572,
            id: result.form_1572.id,
            ffst_version: result.form_1572.ffst_version
          }
        };
        setForm1572Data(tempForm1572Data);
        setSavedFormFields(tempUpdateObj.form_1572);
        setNewFormVersion(result.form_1572.ffst_version);
        setIsFormCreated(true);
        await updateForm1572Query({
          data: tempUpdateObj,
          id: result.form_1572.id,
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME,
          application_module_section: 'STUDY LOGS'
        });
      }
    } else {
      await updateForm1572Query({
        data: tempUpdateObj,
        id: form1572Data.form_1572.id,
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        application: process.env.REACT_APP_NAME,
        application_module_section: 'STUDY LOGS'
      });
    }
  };
  const uploadDataFile = (uploadedDocFile: any) => {
    if (uploadedDocFile) {
      const docToShowInChip = [
        {
          file_master_id: uploadedDocFile.file_master_id,
          document_id: uploadedDocFile.document_data.id,
          document_name: uploadedDocFile.document_data.isf_document_name,
          is_uploaded: true
        }
      ];
      updateFormWithDocData({
        uploaded_file_details: [
          {
            file_id: uploadedDocFile.document_data.id,
            is_uploaded: true
          }
        ]
      });
      setUpdatedDocsList(docToShowInChip);
      getDocsChipList(
        docToShowInChip,
        form1572Data.form_1572.ffst_publish_isf === 'Y',
        form1572Data.form_1572.ffst_signature !== null && form1572Data.form_1572.ffst_signature !== ''
      );
      setIsUploadedDocExisted(false);
    } else {
      dispatch(setMessage({ msgDetails: 'No file choosen.', severity: 'error' }));
    }
  };

  const getDocsChipList = (docsList: any, isFormPublished: boolean, isFormSigned: boolean) => {
    if (docsList.length > 0) {
      const chipsArray: any[] = [];
      docsList.map((file: any, index: number) => {
        (isFormPublished ? true : isFormSigned)
          ? chipsArray.push(
              <Chip
                sx={{ m: 0.3 }}
                label={file.document_name}
                variant="outlined"
                key={index}
                onClick={() => handleDocView(file)}
                disabled={!manageDocsPermission && !viewDocsPermission}
                color="primary"
              />
            )
          : manageDocsPermission
          ? chipsArray.push(
              <Chip
                sx={{ m: 0.3 }}
                label={file.document_name}
                variant="outlined"
                key={index}
                onClick={() => handleDocView(file)}
                onDelete={() => handleChipDelete(file)}
                // disabled={isFormPublished ? true : isFormSigned}
                color="primary"
              />
            )
          : viewDocsPermission
          ? chipsArray.push(
              <Chip
                sx={{ m: 0.3 }}
                label={file.document_name}
                variant="outlined"
                key={index}
                onClick={() => handleDocView(file)}
                // disabled={isFormPublished ? true : isFormSigned}
                color="primary"
              />
            )
          : chipsArray.push(
              <Chip
                sx={{ m: 0.3 }}
                label={file.document_name}
                variant="outlined"
                key={index}
                disabled
                color="primary"
              />
            );
      });
      setDocsChipList(chipsArray);
    } else {
      setDocsChipList([]);
    }
  };
  const handleOpenUploadLinkDocument = (docMetadata: any) => {
    setOpenUploadLinkDocument(true);
    setDocumentMetaData(docMetadata);
  };
  const clearData = () => {
    setDocumentMetaData({ name: '', number: '' });
    handleCloseUploadDocument();
  };
  const print1572Form = async () => {
    try {
      if (
        form1572Data.form_1572.id !== '' &&
        form1572Data.form_1572.id !== null &&
        form1572Data.form_1572.id !== undefined
      ) {
        dispatch(showLoader());
        const options = {
          form_id: form1572Data.form_1572.id,
          template_name: '1572',
          accessToken: token,
          sponsor,
          pathVariables: {
            study_id: studyId,
            site_id: selectedSite,
            country: selectedCountry,
            appName: process.env.REACT_APP_NAME
          }
        };
        printPdfWithViewer('get_form1572_pdf_file', options, 'application/pdf');
        setTimeout(function () {
          dispatch(hideLoader());
        }, 1500);
      } else {
        dispatch(setMessage({ msgDetails: 'Please save the form', severity: 'error' }));
      }
    } catch (error: any) {
      dispatch(hideLoader());
      dispatch(setMessage({ msgDetails: 'Error while fetching pdf', severity: 'error' }));
    }
  };

  const handleOpenUploadDocument = () => {
    setOpenUploadDocument(true);
    setOpenUploadLinkDocument(false);
  };
  const handleCloseUploadDocument = () => {
    setOpenUploadDocument(false);
    setOpenUploadLinkDocument(false);
    setDocumentMetaData({ name: '', number: '' });
  };
  const handleCloseUploadLinkDocument = () => {
    setOpenUploadLinkDocument(false);
  };

  const handleUploadLinkRadioChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.value === 'NEW') {
      if (updatedDocsList.length > 0) {
        setDeleteExistingDocPopup(true);
        handleCloseUploadLinkDocument();
      } else {
        handleOpenUploadDocument();
      }
    } else {
      const docList: any = await getDocsListToLink(documentMetaData);
      if (docList.length > 0) {
        setDocsListToLink(docList);
        if (updatedDocsList.length > 0) {
          setDeleteExistingAndLinkDocPopup(true);
          handleCloseUploadLinkDocument();
        } else {
          handleOpenLinkISFDocument();
        }
      } else {
        dispatch(setMessage({ msgDetails: `Document(s) not available to Link`, severity: 'error' }));
      }
    }
  };
  const getDocsListToLink = async (artifactObj: any) => {
    try {
      dispatch(showLoader());
      const result: any = await getAllISFDocInfoByArtifactNumberSiteLevelData({
        site_id: selectedSite,
        study_id: studyId,
        country: selectedCountry,
        artifactName: artifactObj.name,
        artifactNumber: artifactObj.number,
        originally_uploaded: true,
        application: process.env.REACT_APP_NAME,
        module_section_related: 'STUDY LOGS',
        parent_entity_related: ''
      });
      if (updatedDocsList.length > 0) {
        const newResult =
          result.isSuccess && result?.data && result?.data.selected_data.length > 0
            ? result?.data?.selected_data.filter(
                (docToLink: any) => docToLink.document_data.id !== updatedDocsList[0].document_id
              )
            : [];
        dispatch(hideLoader());
        return newResult;
      } else {
        dispatch(hideLoader());
        if (result.isError) {
          return [];
        } else {
          return result?.data;
        }
      }
    } catch (error: any) {
      dispatch(hideLoader());
      return [];
    }
  };
  const handleOpenLinkISFDocument = () => {
    handleCloseUploadLinkDocument();
    setOpenLinkISFDocument(true);
  };
  const handleCloseLinkISFDocument = () => {
    setExistingISFDocId('');
    setOpenLinkISFDocument(false);
  };
  const handleSubmitLinkISFDocument = () => {
    if (existingISFDocId !== '') {
      const selectedDoc: any = docsListToLink.find((doc: any) => doc.document_data.id === existingISFDocId);
      const tempDocList = [
        {
          file_master_id: selectedDoc.file_master.id,
          document_id: selectedDoc.document_data.id,
          document_name: selectedDoc.document_data.isf_document_name,
          is_uploaded: false
        }
      ];
      updateFormWithDocData({
        uploaded_file_details: [
          {
            file_id: existingISFDocId,
            is_uploaded: false
          }
        ]
      });
      setUpdatedDocsList(tempDocList);
      getDocsChipList(
        tempDocList,
        form1572Data.form_1572.ffst_publish_isf === 'Y',
        form1572Data.form_1572.ffst_signature !== null && form1572Data.form_1572.ffst_signature !== ''
      );
      handleCloseLinkISFDocument();
      dispatch(setMessage({ msgDetails: 'Document linked successfully', severity: 'success' }));
    }
  };

  const hadleExistingISFDocumentSelect = (event: SelectChangeEvent) => {
    setExistingISFDocId(event.target.value);
  };

  return (
    <>
      <Loader />
      <Grid container mb={2} sx={{ position: 'sticky' }}>
        <Grid md={6}>
          {isBacktoSitepersonnel ? (
            <Button onClick={handleBack1572} startIcon={<ArrowBackIcon fontSize="small" />}>
              back to site personnel details
            </Button>
          ) : (
            <Button onClick={handleBack1572} startIcon={<ArrowBackIcon fontSize="small" />}>
              LIST OF LOGS
            </Button>
          )}
          / 1572
        </Grid>
        <Grid md={6} sx={{ display: 'flex', textAlign: 'right', justifyContent: 'right' }}>
          <Stack direction="row" spacing={0.2}>
            <Button
              onClick={() => setConfirmNewVersion(true)}
              disabled={
                !updatePermission ||
                form1572Data.form_1572.ffst_publish_isf === null ||
                form1572Data.form_1572.ffst_publish_isf === ''
              }
            >
              CREATE NEW VERSION
            </Button>
            <Button onClick={saveForm1572} disabled={isFieldDisabled || !isFormUpdated}>
              SAVE
            </Button>
            <Button onClick={print1572Form}>
              <LocalPrintshopIcon fontSize="medium" />
            </Button>
          </Stack>
        </Grid>
      </Grid>
      <div className="form-1572 studyLogForm">
        <Grid container>
          <Grid md={12}>
            <Box>
              <div className="formList">
                <h4 className="formSubHeader">1. Name and Address of Investigator</h4>
                <Grid container spacing={2}>
                  <Grid item md={12}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_name_investigator}
                      helperText={validationObj.ffst_name_investigator && 'Required'}
                      name="ffst_name_investigator"
                      className="fieldRequired"
                      label="Name of Clinical Investigator"
                      id="nameClinic"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_name_investigator || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 100,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>

                  <Grid item xs={6} md={6}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_add1_inv}
                      helperText={validationObj.ffst_add1_inv && 'Required'}
                      name="ffst_add1_inv"
                      className="fieldRequired"
                      label="Address 1"
                      id="studyAddress1"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_add1_inv || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 100,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                      fullWidth
                      name="ffst_add2_inv"
                      label="Address 2"
                      id="studyAddress2"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_add2_inv || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 100,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>

                  <Grid item xs={6} md={3}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_add_city_inv}
                      helperText={validationObj.ffst_add_city_inv && 'Required'}
                      name="ffst_add_city_inv"
                      className="fieldRequired"
                      label="City"
                      id="studyCity"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_add_city_inv || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 50,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_add_state_inv}
                      helperText={validationObj.ffst_add_state_inv && 'Required'}
                      name="ffst_add_state_inv"
                      className="fieldRequired"
                      label="State/Province/Region"
                      id="studyState"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_add_state_inv || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 50,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_add_country_inv}
                      helperText={validationObj.ffst_add_country_inv && 'Required'}
                      name="ffst_add_country_inv"
                      className="fieldRequired"
                      label="Country"
                      id="studyCountry"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_add_country_inv || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 50,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_add_zip_inv}
                      helperText={validationObj.ffst_add_zip_inv && 'Required'}
                      name="ffst_add_zip_inv"
                      className="fieldRequired"
                      label="Zip or Postal Code"
                      id="studyZip"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_add_zip_inv || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 50,
                        inputMode: 'numeric',
                        pattern: '[0-9]*',
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
              <div className="formList">
                <h4 className="formSubHeader">
                  2. Education, Training, and Experience that Qualify the Investigator as an Expert in the Clinical
                  Investigation of the Drug for the Use Under Investigation. One of the Following is Provided (Select
                  One of the Following). <span style={{ color: 'red' }}>*</span>
                </h4>
                <Grid item xs={12} md={12}>
                  <FormControl
                    error={validationObj.ffst_inv_cv || validationObj.ffst_inv_other_qualifications}
                    variant="standard"
                  >
                    <RadioGroup
                      row
                      aria-labelledby="demo-radio-buttons-group-label"
                      // defaultValue=""
                      name="radio-buttons-group"
                      onChange={(e: any) => handleEduRadioFieldChange(e)}
                    >
                      <Grid item xs={6} md={6}>
                        <FormControlLabel
                          value={'Y'}
                          checked={form1572Data.form_1572.ffst_inv_cv === 'Y' ? true : false}
                          control={<Radio name="ffst_inv_cv" disabled={isFieldDisabled} />}
                          label="Curriculum Vitae"
                        />
                        {form1572Data.form_1572.ffst_inv_cv === 'Y' ? (
                          <div>
                            {manageDocsPermission ? (
                              <div>
                                <Button
                                  variant="contained"
                                  sx={{ my: 1 }}
                                  disabled={
                                    !(updatePermission && manageDocsPermission) ||
                                    !(
                                      form1572Data.form_1572.ffst_signature === null ||
                                      form1572Data.form_1572.ffst_signature === ''
                                    )
                                  }
                                  onClick={() => handleOpenUploadLinkDocument(uploadDocArtifacts.cv)}
                                >
                                  UPLOAD/LINK DOCUMENT
                                </Button>
                                <br />
                              </div>
                            ) : (
                              <></>
                            )}

                            <Box className="docChipsWrap" sx={{ my: 0.5 }}>
                              {docsChipList}
                            </Box>
                          </div>
                        ) : (
                          <></>
                        )}
                      </Grid>
                      <Grid item xs={6} md={6}>
                        <FormControlLabel
                          value={'Y'}
                          checked={form1572Data.form_1572.ffst_inv_other_qualifications === 'Y' ? true : false}
                          control={<Radio name="ffst_inv_other_qualifications" disabled={isFieldDisabled} />}
                          label="Other Statement of Qualifications"
                        />
                        {form1572Data.form_1572.ffst_inv_other_qualifications === 'Y' ? (
                          <div>
                            {manageDocsPermission ? (
                              <div>
                                <Button
                                  variant="contained"
                                  sx={{ my: 1 }}
                                  disabled={
                                    !(updatePermission && manageDocsPermission) ||
                                    !(
                                      form1572Data.form_1572.ffst_signature === null ||
                                      form1572Data.form_1572.ffst_signature === ''
                                    )
                                  }
                                  onClick={() => handleOpenUploadLinkDocument(uploadDocArtifacts.osq)}
                                >
                                  UPLOAD/LINK DOCUMENT
                                </Button>
                                <br />
                              </div>
                            ) : (
                              <></>
                            )}
                            <Box className="docChipsWrap" sx={{ my: 0.5 }}>
                              {docsChipList}
                            </Box>
                          </div>
                        ) : (
                          <></>
                        )}
                      </Grid>
                    </RadioGroup>
                    <FormHelperText>
                      {validationObj.ffst_inv_cv || validationObj.ffst_inv_other_qualifications
                        ? 'Select any one option'
                        : ''}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </div>
              <div className="formList">
                <h4 className="formSubHeader">
                  3. Name and Address of Any Medical School, Hospital, or Other Research Facility Where the Clinical
                  Investigation(s) will be Conducted
                </h4>
                <Grid container spacing={2}>
                  <Grid item md={12}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_name_rfac}
                      helperText={validationObj.ffst_name_rfac && 'Required'}
                      name="ffst_name_rfac"
                      className="fieldRequired"
                      label="Name of Medical School, Hospital, or Other Research Facility"
                      id="nameClinic"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_name_rfac || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 100,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>

                  <Grid item xs={6} md={6}>
                    <TextField
                      error={validationObj.ffst_add1_rfac}
                      helperText={validationObj.ffst_add1_rfac && 'Required'}
                      name="ffst_add1_rfac"
                      fullWidth
                      className="fieldRequired"
                      label="Address 1"
                      id="studyAddress1"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_add1_rfac || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 100,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                      fullWidth
                      name="ffst_add2_rfac"
                      label="Address 2"
                      id="studyAddress2"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_add2_rfac || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 100,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>

                  <Grid item xs={6} md={3}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_city_rfac}
                      helperText={validationObj.ffst_city_rfac && 'Required'}
                      name="ffst_city_rfac"
                      className="fieldRequired"
                      label="City"
                      id="studyCity"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_city_rfac || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 50,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_state_rfac}
                      helperText={validationObj.ffst_state_rfac && 'Required'}
                      name="ffst_state_rfac"
                      className="fieldRequired"
                      label="State/Province/Region"
                      id="studyState"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_state_rfac || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 50,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_country_rfac}
                      helperText={validationObj.ffst_country_rfac && 'Required'}
                      name="ffst_country_rfac"
                      className="fieldRequired"
                      label="Country"
                      id="studyCountry"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_country_rfac || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 50,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_zip_rfac}
                      helperText={validationObj.ffst_zip_rfac && 'Required'}
                      name="ffst_zip_rfac"
                      className="fieldRequired"
                      label="Zip or Postal Code"
                      id="studyZip"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_zip_rfac || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 50,
                        inputMode: 'numeric',
                        pattern: '[0-9]*',
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
              <div className="formList">
                <h4 className="formSubHeader">
                  4. Name and Address of Any Clinical Laboratory Facilities to be Used in the Study
                </h4>
                <Grid container spacing={2}>
                  <Grid item md={12}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_name_clinlab}
                      helperText={validationObj.ffst_name_clinlab && 'Required'}
                      name="ffst_name_clinlab"
                      className="fieldRequired"
                      label="Name of Clinical Laboratory Facility"
                      id="nameClinic"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_name_clinlab || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 100,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>

                  <Grid item xs={6} md={6}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_add1_clinlab}
                      helperText={validationObj.ffst_add1_clinlab && 'Required'}
                      name="ffst_add1_clinlab"
                      className="fieldRequired"
                      label="Address 1"
                      id="studyAddress1"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_add1_clinlab || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 100,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                      fullWidth
                      name="ffst_add2_clinlab"
                      label="Address 2"
                      id="studyAddress2"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_add2_clinlab || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 100,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>

                  <Grid item xs={6} md={3}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_city_clinlab}
                      helperText={validationObj.ffst_city_clinlab && 'Required'}
                      name="ffst_city_clinlab"
                      className="fieldRequired"
                      label="City"
                      id="studyCity"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_city_clinlab || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 50,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_state_clinlab}
                      helperText={validationObj.ffst_state_clinlab && 'Required'}
                      name="ffst_state_clinlab"
                      className="fieldRequired"
                      label="State/Province/Region"
                      id="studyState"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_state_clinlab || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 50,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_country_clinlab}
                      helperText={validationObj.ffst_country_clinlab && 'Required'}
                      name="ffst_country_clinlab"
                      className="fieldRequired"
                      label="Country"
                      id="studyCountry"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_country_clinlab || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 50,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_zip_clinlab}
                      helperText={validationObj.ffst_zip_clinlab && 'Required'}
                      name="ffst_zip_clinlab"
                      className="fieldRequired"
                      label="Zip or Postal Code"
                      id="studyZip"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_zip_clinlab || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 50,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
              <div className="formList">
                <h4 className="formSubHeader">
                  5. Name and Address of the Institutional Review Board (IRB) that is Responsible for Review and
                  Approval of the Study(ies)
                </h4>
                <Grid container spacing={2}>
                  <Grid item md={12}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_name_irb}
                      helperText={validationObj.ffst_name_irb && 'Required'}
                      name="ffst_name_irb"
                      className="fieldRequired"
                      label="Name of IRB"
                      id="nameClinic"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_name_irb || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 100,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>

                  <Grid item xs={6} md={6}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_add1_irb}
                      helperText={validationObj.ffst_add1_irb && 'Required'}
                      name="ffst_add1_irb"
                      className="fieldRequired"
                      label="Address 1"
                      id="studyAddress1"
                      value={form1572Data.form_1572.ffst_add1_irb || ''}
                      variant="standard"
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 100,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <TextField
                      fullWidth
                      name="ffst_add2_irb"
                      label="Address 2"
                      id="studyAddress2"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_add2_irb || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 100,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>

                  <Grid item xs={6} md={3}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_city_irb}
                      helperText={validationObj.ffst_city_irb && 'Required'}
                      name="ffst_city_irb"
                      className="fieldRequired"
                      label="City"
                      id="studyCity"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_city_irb || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 50,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_state_irb}
                      helperText={validationObj.ffst_state_irb && 'Required'}
                      name="ffst_state_irb"
                      className="fieldRequired"
                      label="State/Province/Region"
                      id="studyState"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_state_irb || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 50,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_country_irb}
                      helperText={validationObj.ffst_country_irb && 'Required'}
                      name="ffst_country_irb"
                      className="fieldRequired"
                      label="Country"
                      id="studyCountry"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_country_irb || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 50,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                  <Grid item xs={6} md={3}>
                    <TextField
                      fullWidth
                      error={validationObj.ffst_zip_irb}
                      helperText={validationObj.ffst_zip_irb && 'Required'}
                      name="ffst_zip_irb"
                      className="fieldRequired"
                      label="Zip or Postal Code"
                      id="studyZip"
                      variant="standard"
                      value={form1572Data.form_1572.ffst_zip_irb || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 50,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
              <div className="formList">
                <h4 className="formSubHeader">6. Name of Subinvestigators (if not applicable, enter ‘None’)</h4>
                <Grid container>
                  <Grid item md={12}>
                    <TextField
                      id="subinvestigators-msg"
                      name="ffst_subinv_names"
                      // label="Subinvestigators Message"
                      multiline
                      minRows={3}
                      variant="standard"
                      placeholder="Type here..."
                      value={form1572Data.form_1572.ffst_subinv_names || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 2000,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
              <div className="formList">
                <h4 className="formSubHeader">
                  7. Name and Code Number, if any, of the Protocol(s) in the IND for the Study(ies) to be Conducted by
                  the Investigator
                </h4>
                <Grid container>
                  <Grid item md={12}>
                    <TextField
                      id="nameNcode-msg"
                      name="ffst_protocol_id"
                      // label="Name and Code Number Message"
                      multiline
                      minRows={3}
                      variant="standard"
                      placeholder="Type here..."
                      value={form1572Data.form_1572.ffst_protocol_id || ''}
                      onChange={handleFieldChange}
                      inputProps={{
                        maxLength: 199,
                        readOnly: isFieldDisabled
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
              <div className="formList">
                <h4 className="formSubHeader">
                  8. Provide the Following Clinical Protocol Information (Select one of the Following)<span style={{ color: 'red'}}>*</span>
                </h4>
                <Grid container>
                  <Grid item md={12} sx={{ mb: 1 }}>
                    <FormControl
                      error={validationObj.ffst_phase1_statement || validationObj.ffst_phase2_or3_statement}
                      variant="standard"
                    >
                      {/* <FormLabel id="demo-radio-buttons-group-label" className="formSubHeader">
                        8. Provide the Following Clinical Protocol Information (Select one of the Following){' '}
                        <span style={{ color: 'red' }}>*</span>
                      </FormLabel> */}
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        defaultValue="female"
                        name="radio-buttons-group"
                        className="radioGroupwLongLabel"
                        onChange={handleProtoRadioFieldChange}
                      >
                        <FormControlLabel
                          value="Y"
                          checked={form1572Data.form_1572.ffst_phase1_statement === 'Y' ? true : false}
                          control={<Radio name="ffst_phase1_statement" disabled={isFieldDisabled} />}
                          label="For Phase 1 invesitgations, a general outline of the planned investigation including the estimated duration of the study and the maximum number of subjects that will be involved."
                        />
                        <FormControlLabel
                          value="Y"
                          checked={form1572Data.form_1572.ffst_phase2_or3_statement === 'Y' ? true : false}
                          control={<Radio name="ffst_phase2_or3_statement" disabled={isFieldDisabled} />}
                          label="For Phase 2 or 3 investigations, an outline of the study protocol including an approximation of the number of subjects to be treated with the drug and the number to be employed as controls, if any; the clinical uses to be investigated; characteristics of subjects by age, sex and condition; the kind of clinical observations and laboratory tests to be conducted; the estimated duration of the study; and copies or a description of case report forms to be used"
                        />
                      </RadioGroup>
                      <FormHelperText>
                        {validationObj.ffst_phase1_statement || validationObj.ffst_phase2_or3_statement
                          ? 'Select any one option'
                          : ''}
                      </FormHelperText>
                    </FormControl>
                  </Grid>
                  <h4 className="formSubHeader">Instructions for Completing Form FDA 1572 Statement Investigator</h4>
                  <ol>
                    <li>Complete all sections. Provide a separate page if additional space is needed.</li>
                    <li>Provide curriculum vitae or other statement of qualifications as described in Section 2.</li>
                    <li>Provide protocol outline as described in Section 8.</li>
                    <li>Sign and date below.</li>
                    <li>
                      FORWARD THE COMPLETED FORM AND OTHER DOCUMENTS BEING PROVIDED TO THE SPONSOR. The sponsor will
                      incorporate this information along with other technical data into an Investigational New Drug
                      Application (IND). INVESTIGATORS SHOULD NOT SEND THIS FORM DIRECTLY TO THE FOOD AND DRUG
                      ADMINISTRATION.
                    </li>
                  </ol>
                </Grid>
              </div>
              <div className="formList">
                <h4 className="formSubHeader">9. Commitments</h4>
                <Grid container>
                  <Grid item md={12}>
                    <p>
                      I agree to conduct the study(ies) in accordance with the relevant, current protocol(s) and will
                      only make changes in a protocol after notifying the sponsor, except when necessary to protect the
                      safety, rights, or welfare of subjects.
                    </p>

                    <p>I agree to personally conduct or supervise the described investigation(s).</p>
                    <p>
                      I agree to inform any patients, or any persons used as controls, that the drugs are being used for
                      investigational purposes and I will ensure that the requirements relating to obtaining informed
                      consent in 21 CFR Part 50 and institutional review board (IRB) review and approval in 21 CFR Part
                      56 are met.
                    </p>

                    <p>
                      I agree to report to the sponsor adverse experiences that occur in the course of the
                      investigation(s) in accordance with 21 CFR 312.64. I have read and understand the information in
                      the investigator’s brochure, including the potential risks and side effects of the drug.
                    </p>
                    <p>
                      I agree to ensure that all associates, colleagues, and employees assisting in the conduct of the
                      study(ies) are informed about their obligations in meeting the above commitments.
                    </p>

                    <p>
                      I agree to maintain adequate and accurate records in accordance with 21 CFR 312.62 and to make
                      those records available for inspection in accordance with 21 CFR 312.68.
                    </p>

                    <p>
                      I will ensure that an IRB that complies with the requirements of 21 CFR Part 56 will be
                      responsible for the initial and continuing review and approval of the clinical investigation. I
                      also agree to promptly report to the IRB all changes in the research activity and all
                      unanticipated problems involving risks to human subjects or others. Additionally, I will not make
                      any changes in the research without IRB approval, except where necessary to eliminate apparent
                      immediate hazards to human subjects.
                    </p>

                    <p>
                      I agree to comply with all other requirements regarding the obligations of clinical investigators
                      and all other pertinent requirements in 21 CFR Part 312.
                    </p>
                  </Grid>
                </Grid>
              </div>
              <div className="formList">
                <h4 className="formSubHeader">10. Date and Signature</h4>
                <Grid container spacing={2}>
                  <Grid item md={12} display="flex" alignItems="flex-end">
                    {form1572Data.form_1572.ffst_signature === null || form1572Data.form_1572.ffst_signature === '' ? (
                      <Button
                        variant="contained"
                        disabled={!(signPermission && !isFormUpdated && isFormCreated)}
                        onClick={() => handleSignOpen()}
                      >
                        Sign
                      </Button>
                    ) : (
                      <Box sx={{ display: 'inline-flex', alignItems: 'center' }}>
                        <span className="signedInfo">
                          Signed by <strong>{form1572Data?.form_1572?.ffst_signature}</strong> on{' '}
                          <span color="text.secondary">
                            {getPreferredDateTimeInLocal(form1572Data?.form_1572?.ffst_date_signed)}
                          </span>{' '}
                          <br />
                          <span className="signReasonrow">
                            <span color="text.secondary">Reason:</span> &ldquo;{form1572Data?.form_1572?.reason}
                            &rdquo;
                          </span>
                        </span>
                      </Box>
                    )}
                    <Button
                      variant="contained"
                      disabled={isPublishDisabled()}
                      onClick={() => handlePublishForm1572()}
                      sx={{ alignSelf: 'center', minWidth: '130px', ml: 2 }}
                    >
                      PUBLISH TO ISF
                    </Button>
                  </Grid>
                </Grid>
              </div>

              <Grid className="formList">
                <h4 className="formSubHeader">
                  (WARNING: A willfully false statement is a criminal offense. U.S.C. Title 18, Sec. 1001.)
                </h4>

                <Grid container>
                  <Grid item md={12}>
                    <p>The information below applies only to requirements of the Paperwork Reduction Act of 1995. </p>
                    <p>
                      The burden time for this collection of information is estimated to average 100 hours per response,
                      including the time to review instructions, search existing data sources, gather and maintain the
                      data needed and complete and review the collection of information. Send comments regarding this
                      burden estimate or any other aspect of this information collection, including suggestions for
                      reducing this burden to the address to the right:{' '}
                    </p>
                    <p>
                      “An agency may not conduct or sponsor, and a person is not required to respond to, a collection of
                      information unless it displays a currently valid OMB number.”
                    </p>
                    <p>
                      Department of Health and Human Services Food and Drug Administration
                      <br />
                      Office of Operations
                      <br />
                      Paperwork Reduction Act (PRA) Staff PRAStaff@fda.hhs.gov{' '}
                    </p>
                    {/* <p>&nbsp;</p> */}
                    DO NOT SEND YOUR COMPLETED FORM TO THIS PRA STAFF EMAIL ADDRESS
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
        <div>
          <PopupComponent aria-labelledby="customized-dialog-title" open={openUploadLinkDocument} maxWidth="md">
            <Loader />
            <DialogTitle>Upload or Link Document</DialogTitle>
            <DialogContent sx={{ width: '500px' }} className="request-access-modal">
              <FormControl error={false} variant="standard">
                <RadioGroup
                  aria-labelledby="radio-buttons-group-label"
                  name="radio-buttons-group"
                  onChange={(e: any) => handleUploadLinkRadioChange(e)}
                >
                  <FormControlLabel
                    value={'NEW'}
                    control={<Radio name="new_document" />}
                    label="Upload a new document"
                  />
                  <FormControlLabel
                    value={'EXISTING'}
                    control={<Radio name="existing_document" />}
                    label="Link to an existing document in ISF"
                  />
                </RadioGroup>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button className="grey-btn" onClick={() => handleCloseUploadLinkDocument()}>
                CANCEL
              </Button>
            </DialogActions>
          </PopupComponent>
        </div>
        <div>
          <PopupComponent aria-labelledby="customized-dialog-title" open={openLinkISFDocument} maxWidth="md">
            <DialogTitle>Link Document</DialogTitle>
            <DialogContent sx={{ width: '500px' }} className="request-access-modal">
              <FormControl variant="standard">
                <InputLabel>Link to Existing ISF Document</InputLabel>
                <Select
                  disabled={false}
                  sx={{ textAlign: 'start' }}
                  label="Link to Existing ISF Document"
                  required
                  value={existingISFDocId}
                  onChange={hadleExistingISFDocumentSelect}
                >
                  {docsListToLink &&
                    docsListToLink.map((doc: any) => (
                      <MenuItem key={doc.document_data.id} value={doc.document_data.id}>
                        {doc.document_data.isf_document_name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </DialogContent>
            <DialogActions>
              <Button className="grey-btn" onClick={() => handleCloseLinkISFDocument()}>
                CANCEL
              </Button>
              <Button onClick={() => handleSubmitLinkISFDocument()}>SUBMIT</Button>
            </DialogActions>
          </PopupComponent>
        </div>
        <div>
          <PopupComponent
            onClose={() => handleCloseUploadDocument}
            aria-labelledby="customized-dialog-title"
            open={openUploadDocument}
            maxWidth="md"
          >
            <DialogContent dividers>
              <Form1572DocUpload
                docsChipList={docsChipList}
                openUploadDocument={openUploadDocument}
                setOpenUploadDocument={setOpenUploadDocument}
                documentsHoldingObject={form1572Data}
                documentMetaData={documentMetaData}
                updatedDocsList={updatedDocsList}
                setUpdatedDocsList={setUpdatedDocsList}
                setDocumentMetaData={setDocumentMetaData}
                clearData={clearData}
                uploadDataFile={uploadDataFile}
                uploadDocPermission={manageDocsPermission}
                deleteDocPopup={deleteDocPopup}
                handleDocDeleteconfirm={handleDocDeleteconfirm}
                handleDocDeletePopupClose={handleDocDeletePopupClose}
                isUploadedDocExisted={isUploadedDocExisted}
                setIsUploadOnExisted={setIsUploadedDocExisted}
                originallyAssociated1572Document={originallyAssociated1572Document}
              />
            </DialogContent>
          </PopupComponent>
        </div>
        <PopupComponent
          open={deleteExistingDocPopup}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{`Confirm Upload`}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Delete existing and upload new document?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button className="grey-btn" onClick={handleExistingDocDeletePopupClose}>
              Cancel
            </Button>
            <Button onClick={handleExistingDocDeleteconfirm} autoFocus>
              OK
            </Button>
          </DialogActions>
        </PopupComponent>
        <PopupComponent
          open={deleteExistingAndLinkDocPopup}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{`Confirm Link Document`}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">Delink existing and Link new document?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button className="grey-btn" onClick={handleExistingAndLinkDocDeletePopupClose}>
              Cancel
            </Button>
            <Button onClick={handleExistingAndLinkDocDeleteconfirm} autoFocus>
              OK
            </Button>
          </DialogActions>
        </PopupComponent>
        <PopupComponent
          open={deleteDocPopup}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{'Delete the document?'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">Do you want to delete the document?</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDocDeleteconfirm} autoFocus>
              Yes
            </Button>
            <Button onClick={handleDocDeletePopupClose}>No</Button>
          </DialogActions>
        </PopupComponent>
        <PopupComponent
          open={unSavedChanges}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="confirm-modal"
        >
          <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">{unSavedWarning}</DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => tooltipClosehandle('stay')} className="grey-btn">
              Close
            </Button>
            <Button onClick={() => tooltipClosehandle('move')} autoFocus>
              Ok
            </Button>
          </DialogActions>
        </PopupComponent>
        <PopupComponent
          open={openChangeCVandOSQ}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="confirm-modal"
        >
          <DialogTitle id="alert-dialog-title">{'Confirm Exit'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Available documents will be lost. Do you want to continue?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleCancelChangeCVandOSQ()} className="grey-btn">
              Cancel
            </Button>
            <Button onClick={() => handleConfirmChangeCVandOSQ()} autoFocus>
              Ok
            </Button>
          </DialogActions>
        </PopupComponent>
        <PopupComponent
          open={confirmSign}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="confirm-modal"
        >
          <DialogTitle id="alert-dialog-title">{'Sign'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              By signing this document with an electronic signature, I agree that this is a valid representation of my
              signature.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleSignClose()} className="grey-btn">
              cancel
            </Button>
            <Button onClick={() => handleSignConfirm()} autoFocus>
              confirm
            </Button>
          </DialogActions>
        </PopupComponent>
        <PopupComponent
          open={confirmNewVersion}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="confirm-modal"
        >
          <DialogTitle id="alert-dialog-title">{'Confirmation'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to create a new 1572 form?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => handleCreateNewFormClose()} className="grey-btn">
              cancel
            </Button>
            <Button onClick={() => handleCreateNewFormConfirm()} autoFocus>
              confirm
            </Button>
          </DialogActions>
        </PopupComponent>
        {openSignConsent && (
          <ESignConsentReAuth
            openSignConsent={openSignConsent}
            setOpenSignConsent={setOpenSignConsent}
            handleConfirmSign={handle1572FormSign}
          />
        )}
      </div>
    </>
  );
};
export default Form1572;
